export const _en = {
    id: {
        label: "Id"
    },
    name: {
        label: "Name"
    },
    description: {
        label: "Description"
    },
    lastModificationDate: {
        label: "Last modification date"
    }
};

export const _fr = {
    id: {
        label: "Id"
    },
    name: {
        label: "Nom"
    },
    description: {
        label: "Description"
    },
    lastModificationDate: {
        label: "Date de dernière modification"
    }
};